export default "__VITE_ASSET__V3IS0RK33loChjoSkOOTjQ__"